import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import { green } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar1: {
    background: 'rgb(2,0,36)',
    background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 21%, rgba(0,212,255,1) 100%)',
    height: "100px",
    width: "150px"
  },
  avatar2: {
    background: 'rgb(131,58,180)',
    background: 'linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%)',
    height: "100px",
    width: "150px"
  },  
  avatar3: {
    background: 'rgb(34,193,195)',
    background: 'linear-gradient(90deg, rgba(34,193,195,1) 0%, rgba(34,193,195,1) 48%, rgba(45,253,100,0.9612219887955182) 100%)',
    height: "100px",
    width: "150px"
  },  
  avatar4: {
    background: 'rgb(74,34,195)',
    background: 'linear-gradient(90deg, rgba(74,34,195,1) 0%, rgba(195,34,175,1) 53%, rgba(253,45,178,1) 100%)',
    height: "100px",
    width: "150px"
  },      
  section3: {
    margin: theme.spacing(3, 1, 1),
  }  
}));

export default function RecipeReviewCard() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
     <Grid container spacing={3}>
        <Grid item xs={6} sm={3}>
        <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar className={classes.avatar1}>
            $ 19.99 / audit
          </Avatar>
        }
        title={<span style={{fontSize: 'initial'}}><strong>Lite</strong></span>}
        subheader=""
      />
      <CardContent style={{ textAlign: 'center' }}>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />    Less than 20 Audits
        </Typography>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />Live chat support
        </Typography>    
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}}/>Email support
        </Typography>             
      </CardContent>
      {/* <CardActions disableSpacing style={{ placeContent: 'center'}}>
      <div className={classes.section3}>
        <Button variant="contained" color="primary">Buy Now</Button>
      </div>          
      </CardActions> */}
    </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
        <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar className={classes.avatar2}>
            $ 15.99 / audit 
          </Avatar>
        }
        title={<span style={{fontSize: 'initial'}}><strong>Essentials</strong></span>}
        subheader=""
      />
      <CardContent style={{ textAlign: 'center' }}>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />    20 - 100 Audits
        </Typography>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />Live chat support
        </Typography>    
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}}/>Email support
        </Typography>             
      </CardContent>
      {/* <CardActions disableSpacing style={{ placeContent: 'center'}}>
      <div className={classes.section3}>
        <Button variant="contained" color="primary">Buy Now</Button>
      </div>          
      </CardActions> */}
    </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
        <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar className={classes.avatar3}>
            $ 11.99 / audit
          </Avatar>
        }
        title={<span style={{fontSize: 'initial'}}><strong>Scale</strong></span>}
        subheader=""
      />
      <CardContent style={{ textAlign: 'center' }}>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />    100 - 250 Audits
        </Typography>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />Live chat support
        </Typography>    
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}}/>Email support
        </Typography>             
      </CardContent>
      {/* <CardActions disableSpacing style={{ placeContent: 'center'}}>
      <div className={classes.section3}>
        <Button variant="contained" color="primary">Buy Now</Button>
      </div>          
      </CardActions> */}
    </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
        <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar className={classes.avatar4}>
            $ 9.99 / audit
          </Avatar>
        }
        title={<span style={{fontSize: 'initial'}}><strong>Enterprise</strong></span>}
        subheader=""
      />
      <CardContent style={{ textAlign: 'center' }}>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />   More than 250 Audits
        </Typography>
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}} />Live chat support
        </Typography>    
        <Typography style={{ marginBottom: "5px" }} variant="body3" color="textSecondary" component="p">
        <CheckIcon style={{ color: green[500]}}/>Email support
        </Typography>             
      </CardContent>
      {/* <CardActions disableSpacing style={{ placeContent: 'center'}}>
      <div className={classes.section3}>
        <Button variant="contained" color="primary">Buy Now</Button>
      </div>          
      </CardActions> */}
    </Card>
        </Grid>
      </Grid>    
    </> 
  );
}